module.exports = __webpack_public_path__ + "components/nearby-points/static/photo-7-732f32db3a53d38f0a8061f286c95d2f.jpg";